function camelToSnakeCase(str) {
    return str.replace(/[A-Z]|\d+/g, (match, index) => (index !== 0 ? '-' : '') + match.toLowerCase());
}
export const convertToCSSVariables = (variables, prefix = '') => {
    let cssVariables = '';
    for (const key in variables) {
        const snakeCaseKey = camelToSnakeCase(key);
        if (typeof variables[key] === 'object') {
            const newPrefix = prefix ? `${prefix}-${snakeCaseKey}` : snakeCaseKey;
            cssVariables += convertToCSSVariables(variables[key], newPrefix);
        }
        else {
            const cssVariableName = prefix
                ? `--${prefix}-${snakeCaseKey}`
                : `--${snakeCaseKey}`;
            cssVariables += `${cssVariableName}: ${variables[key]};\n`;
        }
    }
    return cssVariables;
};
//# sourceMappingURL=convert-to-css-variables.js.map